export const twoDigits = (n) => {
    return `00${n}`.slice(-2);
};